import { DataContext } from 'hooks/HeaderContext';
import React, { FC, useContext } from 'react';

const DogListSortSelect: FC = () => {
    const { sortType, setSortType } = useContext(DataContext)
    return (
        <div className="form-floating dog-list-sort-select" >
            <select className="form-select " id="floatingSelect"
                aria-label="Floating label select example"
                onChange={(e) => setSortType(e.currentTarget.value)}
                onInput={(e) => setSortType(e.currentTarget.value)}
                value={sortType}
            >
                <option value="name">Name</option>
                <option value="newest">Newest Addition</option>
                <option value="oldest">Oldest Addition</option>
                <option value="breed">Breed</option>
            </select>
            <label htmlFor='floatingSelect'>Sort By:</label>
        </div>
    )
}

export default DogListSortSelect;




















